import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight, FaComment } from "react-icons/fa";
import "./News.css";


const newsData = [
  {
    id: 1,
    date: "18 Nov",
    title: "Assured Life Mortality Table is currently 80% complete",
    image: "images/News/news1.jpg",
    link: "/LatestNews_1",
  },
  {
    id: 2,
    date: "19 Nov",
    title: "A look at regulations of financial services",
    image: "images/News/news2.jpg",
    link: "/LatestNews_2",
  },
  {
    id: 3,
    date: "13 Jun",
    title: "GSS, actuaries to develop National Mortality Table",
    image: "images/News/news3.jpeg",
    link: "/LatestNews_3",
  },
  {
    id: 4,
    date: "14 Jun",
    title: "Government collaborates with insurance and pension regulators",
    image: "images/News/news4.jpeg",
    link: "/LatestNews_4",
  },
  {
    id: 5,
    date: "15 May",
    title: "Insurance industry urged to support development of actuarial science professionals",
    image: "images/News/news2.jpg",
    link: "/LatestNews_5",
  },

];

function News() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatic scrolling every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextNews();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  // Next news card
  const nextNews = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % newsData.length);
  };

  // Previous news card
  const prevNews = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + newsData.length) % newsData.length);
  };

  // Slice to show 3 cards
  const visibleNews = [
    newsData[currentIndex],
    newsData[(currentIndex + 1) % newsData.length],
    newsData[(currentIndex + 2) % newsData.length],
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="news-section">
      <h2 className="news-heading">Our Latest News</h2>
      <div className="news-carousel">
        <button className="arrow-btn left-arrow" onClick={prevNews}>
          <FaArrowLeft />
        </button>
        <div className="news-cards">
          {visibleNews.map((news) => (
            <div key={news.id} className="news-card">
              <Link to={news.link}>
                <img
                  src={news.image}
                  alt={news.title}
                  className="news-image"
                />
                <div className="news-overlay">
                  <p className="news-date">{news.date}</p>
                  <div>
                    <h3 className="news-title">{news.title}</h3>
                  </div>
                </div>
              </Link>
              <div className="news-footer">
                <FaComment className="comment-icon" />
                <span className="comment-text">Leave a Comment</span>
              </div>
            </div>
          ))}
        </div>
        <button className="arrow-btn right-arrow" onClick={nextNews}>
          <FaArrowRight />
        </button>
      </div>
    </section>
  );
}

export default News;
